function PatientHestiaMeedyVO(id, walletGeneral, walletDentist, walletCardiologist, patient, allowDocumentation, institution, email) {

    this.id = id;
    this.walletGeneral = walletGeneral;
    this.walletDentist = walletDentist;
    this.walletCardiologist = walletCardiologist;
    this.patient = patient;
    this.allowDocumentation = allowDocumentation;
    this.institution = institution;
    this.email = email;

    var _typeContext = {
        birthday : Date,
        address : AddressVO,
        statusReason : StatusReasonVO,
        insurer : InsurerMeedyVO,
        patientHestia : PatientHestiaMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
